/*
 * 诊疗服务/便民服务模块
 * 互联网总医院上线后，便民服务功能模块下沉到二级页面，统一在这里管理
 * @Date: 2023-12-28
 */

export default [
  // {
  //     path: "/home",
  //     name: "homerevision",
  //     component: resolve => require(["../components/home/home"], resolve),
  //     meta: {
  //         title: "四川省互联网总医院"
  //         // keepAlive:true
  //     }
  // },
  // {
  //     path: "/oldHome", // 新改版的首页 - 互联网总医院之前
  //     name: "home",
  //     component: resolve => require(["../views/homepage/home/home"], resolve),
  //     meta: {
  //         title: "四川省互联网总医院"
  //         // keepAlive: true
  //     }
  // },
  // {
  //     path: "/homeTest",
  //     name: "homeTest",
  //     component: resolve => require(["../components/home/homeTest"], resolve),
  //     meta: {
  //         title: "四川省互联网总医院"
  //         // keepAlive: true
  //     }
  // },
  //在线问诊 onlineInquiry.vue
  {
    path: "/onlineInquiry",
    name: "onlineInquiry",
    component: resolve =>
      require(["../../components/home/onlineInquiry"], resolve),
    meta: {
      title: "在线问诊"
    }
  },
  {
    path: "/convenientService",
    name: "convenientService",
    component: resolve =>
      require(["../../components/home/convenientService"], resolve),
    meta: {
      title: "生育服务",
      noNeedAuth: true
    }
  },
  {
    path: "/yellowUser",
    name: "yellowUser",
    component: resolve =>
      require(["../../components/home/yellowUser"], resolve),
    meta: {
      title: "“黄码”人员定点医疗卫生服务机构",
      noNeedAuth: true
    }
  },
  {
    path: "/urgentYiq",
    name: "urgentYiq",
    component: resolve => require(["../../components/home/urgentYiq"], resolve),
    meta: {
      title: "四川省24小时传染病分级诊疗咨询服务",
      noNeedAuth: true
    }
  },
  {
    path: "/urgentYiqOrgan",
    name: "urgentYiqOrgan",
    component: resolve =>
      require(["../../components/home/urgentYiqOrgan"], resolve),
    meta: {
      title: "新冠病毒核酸检测机构信息",
      noNeedAuth: true
    }
  },

  {
    path: "/urgentYiqChild",
    name: "urgentYiqChild",
    component: resolve =>
      require(["../../components/home/urgentYiqChild"], resolve),
    meta: {
      noNeedAuth: true
    }
  },
  {
    path: "/organChild",
    name: "organChild",
    component: resolve =>
      require(["../../components/home/organChild"], resolve),
    meta: {
      title: "新冠病毒核酸检测机构信息",
      noNeedAuth: true
    }
  },
  {
    path: "/feverYiqChild",
    name: "feverYiqChild",
    component: resolve =>
      require(["../../components/home/feverYiqChild"], resolve),
    meta: {
      noNeedAuth: true
    }
  },
  {
    path: "/feverYiqChildPoint",
    name: "feverYiqChildPoint",
    component: resolve =>
      require(["../../components/home/feverYiqChild"], resolve),
    meta: {
      title: "发热哨点",
      noNeedAuth: true
    }
  },
  {
    path: "/feverYiqChildClass",
    name: "feverYiqChildClass",
    component: resolve =>
      require(["../../components/home/feverYiqChild"], resolve),
    meta: {
      title: "发热诊室",
      noNeedAuth: true
    }
  },
  {
    path: "/pointYiqChild",
    name: "pointYiqChild",
    component: resolve =>
      require(["../../components/home/pointYiqChild"], resolve),
    meta: {
      title: "哨点诊室",
      noNeedAuth: true
    }
  },
  {
    path: "/yuyueYiq",
    name: "yuyueYiq",
    component: resolve => require(["../../components/home/yuyueYiq"], resolve),
    meta: {
      title: "咨询预约流程",
      noNeedAuth: true
    }
  },
  {
    path: "/feverNav",
    name: "feverNav",
    component: resolve => require(["../../components/home/feverNav"], resolve),
    meta: {
      title: "发热诊室"
    }
  },
  {
    path: "/feelerNav",
    name: "feelerNav",
    component: resolve => require(["../../components/home/feelerNav"], resolve),
    meta: {
      title: "核酸检测机构"
    }
  },
  {
    path: "/realTimeSituationControl",
    name: "realTimeSituationControl",
    component: resolve =>
      require(["../../components/home/realTimeSituationControl"], resolve),
    meta: {
      title: "防疫专区",
      noNeedAuth: true
    }
  },
  {
    path: "/realTineSituationControl",
    name: "realTineSituationControl",
    component: resolve =>
      require(["../../components/home/realTimeSituationControl"], resolve),
    meta: {
      title: "防疫专区",
      noNeedAuth: true
    }
  },
  {
    path: "/realTimeSituationControlTest",
    name: "realTimeSituationControlTest",
    component: resolve =>
      require(["../../components/home/realTimeSituationControlTest"], resolve),
    meta: {
      title: "防疫专区"
    }
  },
  {
    path: "/hospitalList",
    name: "hospitalList",
    component: resolve =>
      require(["../../components/hospitalList/hospitalList"], resolve),
    meta: {
      title: "医院列表"
    }
  },
  {
    path: "/hospitalLists",
    name: "hospitalLists",
    component: resolve =>
      require(["../../components/hospitalList/hospitalLists"], resolve),
    meta: {
      title: "医院列表"
    }
  },
  {
    path: "/grassrootsHospList",
    name: "grassrootsHospList",
    component: resolve =>
      require(["../../components/hospitalList/grassrootsHospList"], resolve),
    meta: {
      title: "医院列表"
    }
  },
  {
    path: "/hospitalGeneral",
    name: "hospitalGeneral",
    component: resolve =>
      require(["../../components/hospitalList/hospitalGeneral"], resolve),
    meta: {
      title: "医院概况"
    }
  },
  {
    path: "/hosSearchRes",
    name: "hosSearchRes",
    component: resolve =>
      require(["../../components/hospitalList/hosSearchRes"], resolve),
    meta: {
      title: "搜索结果"
    }
  },
  {
    path: "/being",
    name: "being",
    component: resolve => require(["../../components/being"], resolve),
    meta: {
      title: "正在开发中"
    }
  },
  {
    path: "/myCollect",
    name: "myCollect",
    component: resolve =>
      require(["../../components/registration/myCollect"], resolve)
  },

  {
    path: "/searchDoc",
    name: "searchDoc",
    component: resolve =>
      require(["../../components/registration/searchDoc"], resolve),
    meta: {
      title: "搜索"
    }
  },
  {
    path: "/myCode",
    name: "myCode",
    component: resolve =>
      require(["../../components/registration/myCode"], resolve),
    meta: {
      title: "我的二维码"
    }
  },
  //就诊二维码
  {
    path: "/visitCode",
    name: "visitCode",
    component: resolve =>
      require(["../../components/healthCard/visitCode"], resolve),
    meta: {
      title: "我的二维码"
    }
  },
  {
    path: "/showCode",
    name: "showCode",
    component: resolve =>
      require(["../../components/registration/showCode"], resolve),
    meta: {
      title: "查看详情"
    }
  },
  {
    path: "/editHealthCard",
    name: "editHealthCard",
    component: resolve =>
      require(["../../components/healthCard/editHealthCard"], resolve),
    meta: {
      title: "修改信息"
    }
  },
  {
    path: "/personage",
    name: "personage",
    component: resolve =>
      require(["../../components/registration/personage"], resolve),
    meta: {
      title: "个人中心"
    }
  },

  {
    path: "/regHealthCard",
    name: "regHealthCard",
    component: resolve =>
      require(["../../components/healthCard/regHealthCard"], resolve),
    meta: {
      title: "注册/绑定健康卡"
    }
  },
  // 小于14周岁建卡需要填写补充信息(监护人信息)
  {
    path: "/healthCardSupplementInfo",
    name: "healthCardSupplementInfo",
    component: resolve =>
      require([
        "../../components/healthCard/healthCardSupplementInfo"
      ], resolve),
    meta: {
      title: "注册/绑定健康卡"
    }
  },
  {
    path: "/inputReg",
    name: "inputReg",
    component: resolve =>
      require(["../../components/healthCard/inputReg"], resolve)
  },
  {
    path: "/uploadReg",
    name: "uploadReg",
    component: resolve =>
      require(["../../components/healthCard/uploadReg"], resolve)
  },

  {
    path: "/awaitVer",
    name: "awaitVer",
    component: resolve =>
      require(["../../components/healthCard/awaitVer"], resolve),
    meta: {
      title: "人脸识别中"
    }
  },
  {
    path: "/await2",
    name: "await2",
    component: resolve =>
      require(["../../components/healthCard/await2"], resolve),
    meta: {
      title: "建卡中"
    }
  },
  {
    path: "/selectHealthCard",
    name: "selectHealthCard",
    component: resolve =>
      require(["../../components/healthCard/selectHealthCard"], resolve),
    meta: {
      title: "健康卡列表"
    }
  },
  {
    path: "/healthCardList",
    name: "healthCardList",
    component: resolve =>
      require(["../../components/healthCardNew/healthCardList"], resolve),
    meta: {
      title: "选择健康卡" //妇幼服务
    }
  },
  {
    path: "/healthCardPlan",
    name: "healthCardPlan",
    component: resolve =>
      require(["../../components/healthCardNew/healthCardPlan"], resolve),
    meta: {
      title: "选择健康卡" //免疫规划
    }
  },
  {
    path: "/loading",
    name: "loading",
    component: resolve =>
      require(["../../components/healthCard/loading"], resolve),
    meta: {
      title: "加载中"
    }
  },
  {
    path: "/regLog",
    name: "regLog",
    component: resolve =>
      require(["../../components/registration/regLog"], resolve),
    meta: {
      title: "挂号记录"
    }
  },

  {
    path: "/payLog",
    name: "payLog",
    component: resolve =>
      require(["../../components/registration/payLog"], resolve),
    meta: {
      title: "缴费记录"
    }
  },

  {
    path: "/cardBag",
    name: "cardBag",
    component: resolve =>
      require(["../../components/healthCard/cardBag"], resolve),
    meta: {
      title: "卡包"
    }
  },
  // 家庭医生
  {
    path: "/familyDoctorList",
    name: "familyDoctorList",
    component: resolve =>
      require(["../../components/familyDoctor/familyDoctorList"], resolve),
    meta: {
      title: "家庭医生"
    }
  },
  {
    path: "/selectCardDoctor",
    name: "selectCardDoctor",
    component: resolve =>
      require(["../../components/familyDoctor/selectCardDoctor"], resolve),
    meta: {
      title: "选择健康卡"
    }
  },

  {
    path: "/remainOpen",
    name: "remainOpen",
    component: resolve =>
      require(["../../components/personalCenter/remainOpen"], resolve)
  },

  //授权加载中
  {
    path: "/getHealthCardLoading",
    name: "getHealthCardLoading",
    component: resolve =>
      require([
        "../../components/birthRegistration/getHealthCardLoading"
      ], resolve),
    meta: {
      title: "加载中"
    }
  },

  //2.27儿童领卡列表
  {
    path: "/childrenCardList",
    name: "childrenCardList",
    component: resolve =>
      require(["../../components/familyCard/childrenCardList"], resolve),
    meta: {
      title: "儿童领卡"
    }
  },

  {
    path: "/faceRecognition",
    name: "faceRecognition",
    component: resolve =>
      require(["../../components/healthRecord/faceRecognition"], resolve),
    meta: {
      title: "人脸识别"
    }
  },

  //openHealthCardList健康四川
  {
    path: "/openHealthCardList",
    name: "openHealthCardList",
    component: resolve =>
      require(["../../components/personalCenter/openHealthCardList"], resolve),
    meta: {
      title: "一键授权领卡"
    }
  },
  {
    path: "/myCollectHosList",
    name: "myCollectHosList",
    component: resolve =>
      require(["../../components/personalCenter/myCollectHosList"], resolve),
    meta: {
      title: "我的收藏"
    }
  },

  //健康专区
  {
    path: "/sangYuZone",
    name: "sangYuZone",
    component: resolve =>
      require(["../../components/healthMatrix/sangYuZone"], resolve),
    meta: {
      title: "桑瑜康"
    }
  },
  {
    path: "/medicalZone",
    name: "medicalZone",
    component: resolve =>
      require(["../../components/healthMatrix/medicalZone"], resolve),
    meta: {
      title: "中医专区"
    }
  },
  {
    path: "/childZone",
    name: "childZone",
    component: resolve =>
      require(["../../components/healthMatrix/childZone"], resolve),
    meta: {
      title: "孕妇专区"
    }
  },
  //2020.5.19
  {
    path: "/healthTalk",
    name: "healthTalk",
    component: resolve =>
      require(["../../components/healthMatrix/healthTalk"], resolve),
    meta: {
      title: "健康讲座",
      noNeedAuth: true
    }
  },
  {
    path: "/healthTalkVideo",
    name: "healthTalkVideo",
    component: resolve =>
      require(["../../components/healthMatrix/healthTalkVideo"], resolve),
    meta: {
      title: "健康讲座详情"
    }
  },
  {
    path: "/babyQueDoc",
    name: "babyQueDoc",
    component: resolve =>
      require(["../../components/healthMatrix/babyQueDoc"], resolve),
    meta: {
      title: "宝宝快医"
    }
  },
  {
    path: "/mentalHealth",
    name: "mentalHealth",
    component: resolve =>
      require(["../../components/healthMatrix/mentalHealth"], resolve),
    meta: {
      title: "心理健康"
    }
  },

  //健康矩阵
  {
    path: "/matrixHome",
    name: "matrixHome",
    component: resolve =>
      require(["../../components/healthMatrix/matrixHome"], resolve),
    meta: {
      title: "城市服务"
    }
  },
  {
    path: "/prepayLog",
    name: "prepayLog",
    component: resolve =>
      require(["../../components/personalCenter/prepayLog"], resolve),
    meta: {
      title: "住院预缴记录"
    }
  },
  {
    path: "/questionnaireSurvey",
    name: "questionnaireSurvey",
    component: resolve =>
      require(["../../components/healthPage/questionnaireSurvey"], resolve),
    meta: {
      title: "意见反馈"
    }
  },
  {
    path: "/questionnaireSurveyForm",
    name: "questionnaireSurveyForm",
    component: resolve =>
      require(["../../components/healthPage/questionnaireSurveyForm"], resolve),
    meta: {
      title: "意见反馈"
    }
  },
  {
    path: "/healthCdOpenTencentFace",
    name: "healthCdOpenTencentFace",
    component: resolve =>
      require(["../../components/home/healthCdOpenTencentFace"], resolve),
    meta: {
      title: "人脸识别"
    }
  },
  {
    path: "/alreadyOpenedHos",
    name: "alreadyOpenedHos",
    component: resolve =>
      require(["../../components/personalCenter/alreadyOpenedHos"], resolve),
    meta: {
      title: "已开通健康卡医院列表",
      noNeedAuth: true
    }
  },
  {
    path: "/newsTrend",
    name: "newsTrend",
    component: resolve =>
      require(["../../components/newsTrends/newsTrend"], resolve),
    meta: {
      title: "新闻动态"
    }
  },
  {
    path: "/newsDestails",
    name: "newsDestails",
    component: resolve =>
      require(["../../components/newsTrends/newsDestails"], resolve),
    meta: {
      title: "新闻详情"
    }
  },
  //电子处方流转
  {
    path: "/prescription",
    name: "prescription",
    component: resolve =>
      require(["../../components/prescription/drugStore"], resolve),
    meta: {
      title: "电子处方流转"
    }
  },
  {
    path: "/drugChoose",
    name: "drugChoose",
    component: resolve =>
      require(["../../components/prescription/drugChoose"], resolve),
    meta: {
      title: "电子处方流转"
    }
  },
  {
    path: "/drugDetail",
    name: "drugDetail",
    component: resolve =>
      require(["../../components/prescription/drugDetail"], resolve),
    meta: {
      title: "电子处方流转"
    }
  },
  // {
  //     path: '/order',
  //     name: 'order',
  //     component: resolve => require(['../../components/prescription/order'], resolve),
  //     meta: {
  //         title: '电子处方流转'
  //     }
  // },
  {
    path: "/address",
    name: "address",
    component: resolve =>
      require(["../../components/prescription/address"], resolve),
    meta: {
      title: "电子处方流转"
    }
  },
  // {
  //     path: '/addressAdd',
  //     name: 'addressAdd',
  //     component: resolve => require(['../../components/prescription/addressAdd'], resolve),
  //     meta: {
  //         title: '电子处方流转'
  //     }
  // },
  // {
  //     path: '/orderDetail',
  //     name: 'orderDetail',
  //     component: resolve => require(['../../components/prescription/orderDetail'], resolve),
  //     meta: {
  //         title: '电子处方流转'
  //     }
  // },
  {
    path: "/orderPrescription",
    name: "orderPrescription",
    component: resolve =>
      require(["../../components/prescription/orderPrescription"], resolve),
    meta: {
      title: "电子处方流转"
    }
  },
  //客服服务
  {
    path: "/servicePage",
    name: "servicePage",
    component: resolve =>
      require(["../../components/home/servicePage"], resolve),
    meta: {
      title: "问题反馈"
    }
  },
  {
    path: "/serviceResult",
    name: "serviceResult",
    component: resolve =>
      require(["../../components/home/serviceResult"], resolve),
    meta: {
      title: "反馈结果"
    }
  },
  //健康档案
  {
    path: "/healthFile",
    name: "healthFile",
    component: resolve =>
      require(["../../components/personalCenter/healthFile"], resolve),
    meta: {
      title: "健康档案"
    }
  },
  {
    path: "/healthRecord",
    name: "healthRecord",
    component: resolve =>
      require(["../../components/personalCenter/healthRecord"], resolve),
    meta: {
      title: "体检记录"
    }
  },
  {
    path: "/healthOutpatient",
    name: "healthOutpatient",
    component: resolve =>
      require(["../../components/personalCenter/healthOutpatient"], resolve),
    meta: {
      title: "就诊记录"
    }
  },
  //处方详情
  {
    path: "/recipeDetails",
    name: "recipeDetails",
    component: resolve =>
      require(["../../components/home/recipeDetails"], resolve),
    meta: {
      title: "处方详情"
    }
  },

  // 一网通办
  {
    path: "/quickSearch",
    name: "quickSearch",
    component: resolve =>
      require(["../../views/homepage/quick-search/quickSearch"], resolve),
    meta: {
      title: "检查"
    }
  },
  // 互联网医院
  {
    path: "/internetHospital",
    name: "internetHospital",
    component: resolve =>
      require([
        "../../views/internet-hospital/internet-hospital/internetHospital"
      ], resolve),
    meta: {
      title: "互联网医院名称"
    }
  },
  // 互联网医院-医院列表
  {
    path: "/subordinateList",
    name: "subordinateList",
    component: resolve =>
      require([
        "../../views/internet-hospital/internet-hospital/subordinateList"
      ], resolve),
    meta: {
      title: "互联网医院名称"
    }
  },
  //在线问诊-互联网医院
  {
    path: "/internetHospital-online",
    name: "internetHospital-online",
    component: resolve =>
      require([
        "../../views/internet-hospital/internet-hospital/internetHospital-online"
      ], resolve),
    meta: {
      title: "在线问诊入口"
    }
  },

  // 首页搜索
  {
    path: "/searchResult",
    name: "searchResult",
    component: resolve =>
      require([
        "../../views/homepage/search-list/search-result/index"
      ], resolve),
    meta: {
      title: "广元市互联网分院"
    }
  },
  //互联网政策文件
  {
    path: "/medicalPolicy",
    name: "medicalPolicy",
    component: resolve =>
      require([
        "../../views/homepage/medical-policy/medicalPolicy/index"
      ], resolve),
    meta: {
      title: "互联网医疗相关政策"
    }
  },
  {
    path: "/medicalPolicy/singleDoc",
    name: "singleDoc",
    component: resolve =>
      require([
        "../../views/homepage/medical-policy/components/singleDoc"
      ], resolve),
    meta: {
      title: "互联网医疗相关政策"
    }
  },
  {
    path: "/familyManage",
    name: "familyManage",
    component: resolve =>
      require(["../../views/homepage/family-manage/index"], resolve),
    meta: {
      title: "家庭成员管理"
    }
  },

  // 2022-03-18 新处方流转

  {
    path: "/prescriptionFlow",
    name: "prescriptionFlow",
    component: resolve =>
      require([
        "../../components/prescriptionFlow/prescription-flow/index"
      ], resolve),
    meta: {
      title: "选择药店"
    }
  },
  {
    path: "/searchDrugStore",
    name: "searchDrugStore",
    component: resolve =>
      require([
        "../../components/prescriptionFlow/components/searchDrugStore"
      ], resolve),
    meta: {
      title: "选择药店"
    }
  },
  {
    path: "/drugStoreItem",
    name: "drugStoreItem",
    component: resolve =>
      require([
        "../../components/prescriptionFlow/components/drugStoreItem"
      ], resolve),
    meta: {
      title: "选择药店"
    }
  },
  {
    path: "/order",
    name: "order",
    component: resolve =>
      require(["../../components/prescriptionFlow/components/order"], resolve),
    meta: {
      title: "订单"
    }
  },
  {
    path: "/addressAdd",
    name: "addressAdd",
    component: resolve =>
      require([
        "../../components/prescriptionFlow/components/addressAdd"
      ], resolve),
    meta: {
      title: "电子处方流转"
    }
  },
  {
    path: "/orderDetail",
    name: "orderDetail",
    component: resolve =>
      require([
        "../../components/prescriptionFlow/components/order-detail"
      ], resolve),
    meta: {
      title: "电子处方流转"
    }
  },
  // 新处方流转结束

  // 川渝一体化中间判断页面
  {
    path: "/szechwanIntegration",
    name: "szechwanIntegration",
    component: resolve =>
      require(["../../views/szechwanIntegration/szechwanIntegration"], resolve),
    meta: {
      title: "预约挂号"
    }
  },

  {
    path: "/SESsearch",
    name: "SESsearch",
    component: resolve => require(["../../views/SESsearch/SESsearch"], resolve),
    meta: {
      title: "医疗防疫机构查询"
    }
  },

  //脑卒中风险评估
  {
    path: "/evaluation",
    name: "evaluation",
    component: resolve =>
      require(["../../components/evaluation/evaluation"], resolve),
    meta: {
      title: "脑卒中风险评估"
    }
  },
  //脑卒中风险评估结果
  {
    path: "/evaluationDetails",
    name: "evaluationDetails",
    component: resolve =>
      require(["../../components/evaluation/evaluationDetails"], resolve),
    meta: {
      title: "脑卒中风险评估结果"
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/medicalservice.js